<template>
  <div class="monster-codex" :class="{ 'monster-codex--dark': dark }">
    <div v-if="!isMobile || !mobileDetailVisible" class="monster-codex__sidebar">
      <div class="monster-codex__filters">
        <Input
          v-model.trim="keyword"
          search
          clearable
          size="small"
          placeholder="搜索怪物/地图"
          @on-search="selectedMap = ''; loadList()"
          @on-clear="selectedMap = ''; loadList()"
        />
      </div>

      <div class="monster-codex__groups" v-if="codexList.length">
        <section v-for="group in codexGroups" :key="'group-' + group.name" class="monster-codex__group">
          <div class="monster-codex__group-title">
            <span>{{ group.name }}</span>
            <em>{{ group.items.length }} 种</em>
          </div>
          <div class="monster-codex__list">
            <div
              v-for="item in group.items"
              :key="'codex-' + group.name + '-' + item.monsterId"
              class="monster-codex__item"
              :class="{ active: selectedMonsterId === item.monsterId }"
              @click="selectMonster(item)"
            >
              <div class="monster-codex__item-head">
                <span class="monster-codex__item-name">{{ item.name }}</span>
              </div>
              <div class="monster-codex__item-meta">
                <span class="monster-codex__item-label">Lv.{{ item.level || 0 }}</span>
                <span class="monster-codex__item-label" :class="item.attackType === 2 ? 'is-magic' : 'is-power'">
                  {{ item.attackType === 2 ? '灵力' : '力道' }}
                </span>
                <span class="monster-codex__item-label is-map" :title="group.name">{{ group.name }}</span>
              </div>
            </div>
          </div>
        </section>
      </div>

      <div v-else class="monster-codex__empty">暂无怪物图鉴数据</div>
    </div>

    <div ref="detailPanel" class="monster-codex__detail" v-if="detail && (!isMobile || mobileDetailVisible)">
      <div v-if="isMobile" class="monster-codex__mobile-back">
        <Button size="small" @click="backToList">
          <Icon type="ios-arrow-back" />
          返回列表
        </Button>
      </div>
      <div class="monster-codex__hero">
        <div>
          <div class="monster-codex__title-row">
            <h2>{{ detail.name }}</h2>
            <Tag size="small" :color="detail.attackType === 2 ? 'blue' : 'orange'">
              {{ detail.attackType === 2 ? '灵力' : '力道' }}
            </Tag>
            <Tag size="small" color="gold" v-if="detail.prefix">{{ detail.prefix }}</Tag>
          </div>
          <div class="monster-codex__hero-meta">
            <span>等级 {{ detail.level || 0 }}</span>
            <span>元素 {{ formatElement(detail.element) }}</span>
            <span>出没 {{ detail.mapNames && detail.mapNames.length ? detail.mapNames.join('、') : '未知地图' }}</span>
          </div>
        </div>
      </div>

      <div class="monster-codex__section">
        <div class="monster-codex__section-title">基础属性</div>
        <div class="monster-codex__stats">
          <div class="monster-codex__stat"><span>生命</span><strong>{{ detail.life || 0 }}</strong></div>
          <div class="monster-codex__stat"><span>最小攻击</span><strong>{{ formatNumber(detail.attackMin) }}</strong></div>
          <div class="monster-codex__stat"><span>最大攻击</span><strong>{{ formatNumber(detail.attackMax) }}</strong></div>
          <div class="monster-codex__stat"><span>防御力</span><strong>{{ detail.defence || 0 }}</strong></div>
          <div class="monster-codex__stat"><span>法术防御</span><strong>{{ detail.magicDefense || 0 }}</strong></div>
          <div class="monster-codex__stat"><span>元素加成</span><strong>{{ formatPercent(detail.eleAddit) }}</strong></div>
          <div class="monster-codex__stat"><span>暴击概率</span><strong>{{ formatPercent(detail.explode) }}</strong></div>
          <div class="monster-codex__stat"><span>暴击抵抗</span><strong>{{ formatPercent(detail.explodeResist) }}</strong></div>
          <div class="monster-codex__stat"><span>暴击伤害</span><strong>{{ formatPercent(detail.criDamage) }}</strong></div>
          <div class="monster-codex__stat"><span>行动速度</span><strong>{{ formatNumber(detail.speed) }}</strong></div>
          <div class="monster-codex__stat"><span>掉落修为</span><strong>{{ detail.dropExp || 0 }}</strong></div>
          <!-- <div class="monster-codex__stat"><span>增伤</span><strong>{{ formatPercent(detail.damageBoost) }}</strong></div>
          <div class="monster-codex__stat"><span>减伤</span><strong>{{ formatPercent(detail.damageReduct) }}</strong></div> -->
        </div>
      </div>
      <div class="monster-codex__section">
        <div class="monster-codex__section-title">背景故事</div>
        <div class="monster-codex__text">{{ detail.story || '暂无背景故事' }}</div>
        <div class="monster-codex__text">{{ detail.comboDesc || '暂无技能组合描述' }}</div>
         <!-- <div class="monster-codex__text">属性描述：{{ detail.traitDesc || detail.monDescri || '暂无属性描述' }}</div> -->
      </div>
      <div class="monster-codex__section">
        <div class="monster-codex__section-title">技能列表</div>
        <div class="monster-codex__skills" v-if="detail.skills && detail.skills.length">
          <div
            v-for="skill in detail.skills"
            :key="'skill-' + skill.skillId + '-' + skill.skillOrder"
            class="monster-codex__skill-card"
          >
            <div class="monster-codex__skill-head">
              <span class="monster-codex__skill-name">{{ skill.skillName }}</span>
              <Tag size="small" :color="skill.skillTag === '被动' ? 'gold' : 'blue'">{{ skill.skillTag }}</Tag>
            </div>
              <div class="monster-codex__skill-short">{{ skill.skillDesc || skill.shortDesc || '暂无说明' }}</div>
          </div>
        </div>
        <div v-else class="monster-codex__sub-empty">暂无技能信息</div>
      </div>

    </div>

    <div v-else-if="!isMobile || mobileDetailVisible" class="monster-codex__detail monster-codex__detail--empty">
      请选择左侧怪物查看图鉴详情
    </div>
  </div>
</template>

<script>
export default {
  name: 'MonsterCodexPanel',
  props: {
    dark: {
      type: Boolean,
      default: false
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      keyword: '',
      selectedMap: '',
      codexList: [],
      selectedMonsterId: null,
      detail: null,
      mobileDetailVisible: false,
      loading: false
    }
  },
  mounted() {
    this.loadList()
  },
  computed: {
    codexGroups() {
      const groups = []
      const groupMap = {}
      this.codexList.forEach(item => {
        const names = item.mapNames && item.mapNames.length ? item.mapNames : ['未知地图']
        names.forEach(name => {
          const groupName = name || '未知地图'
          if (!groupMap[groupName]) {
            groupMap[groupName] = { name: groupName, items: [] }
            groups.push(groupMap[groupName])
          }
          if (!groupMap[groupName].items.some(existing => existing.monsterId === item.monsterId)) {
            groupMap[groupName].items.push(item)
          }
        })
      })
      return groups
    }
  },
  methods: {
    async loadList() {
      this.loading = true
      try {
        const res = await this.$http.get('/gameChara/monsterCodexList', {
          params: {
            keyword: this.keyword || undefined
          }
        })
        this.codexList = (res && res.data && res.data.data) || []
        if (!this.codexList.length) {
          this.detail = null
          this.selectedMonsterId = null
          return
        }
        const current = this.codexList.find(item => item.monsterId === this.selectedMonsterId) || this.codexList[0]
        await this.selectMonster(current)
      } finally {
        this.loading = false
      }
    },
    async selectMonster(item) {
      if (!item || !item.monsterId) return
      this.selectedMonsterId = item.monsterId
      const res = await this.$http.get('/gameChara/monsterCodexDetail', {
        params: { monsterId: item.monsterId }
      })
      this.detail = (res && res.data && res.data.data) || null
      if (this.isMobile) {
        this.mobileDetailVisible = true
      }
      this.$nextTick(() => {
        if (this.$refs.detailPanel) {
          this.$refs.detailPanel.scrollTop = 0
        }
      })
    },
    backToList() {
      this.mobileDetailVisible = false
    },
    async applyMapFilter(mapName) {
      this.keyword = mapName || ''
      this.selectedMap = mapName || ''
      this.mobileDetailVisible = false
      await this.loadList()
    },
    formatElement(value) {
      const map = {
        1: '金',
        2: '木',
        3: '水',
        4: '火',
        5: '土',
        6: '风',
        7: '雷',
        8: '冰'
      }
      return map[Number(value)] || '无'
    },
    formatPercent(value) {
      const num = Number(value)
      if (!Number.isFinite(num)) return '--'
      const percent = Math.abs(num) <= 1 ? num * 100 : num
      return `${percent.toFixed(2)}%`
    },
    formatNumber(value) {
      const num = Number(value)
      return Number.isFinite(num) ? `${num}` : '--'
    }
  }
}
</script>

<style scoped>
.monster-codex {
  display: flex;
  gap: 16px;
  height: 100%;
  min-height: 520px;
  max-height: 520px;
  overflow: hidden;
}

.monster-codex__sidebar {
  width: 70%;
  flex: 0 0 calc(70% - 8px);
  min-height: 0;
  border-radius: 12px;
  background: #fff;
  border: 1px solid #e8eaec;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.monster-codex__detail {
  flex: 1;
  min-width: 0;
  min-height: 0;
  box-sizing: border-box;
  border-radius: 12px;
  background: #fff;
  border: 1px solid #e8eaec;
  padding: 18px 18px 52px;
  overflow: auto;
  scroll-padding-bottom: 52px;
}

.monster-codex__mobile-back {
  margin-bottom: 12px;
}

.monster-codex__detail--empty,
.monster-codex__empty {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #808695;
  background: #fff;
}

.monster-codex__filters {
  padding: 14px;
  border-bottom: 1px solid #f0f0f0;
  background: #fff;
}

.monster-codex__groups {
  flex: 1;
  min-height: 0;
  padding: 10px 12px 18px;
  overflow-y: auto;
  overflow-x: hidden;
}

.monster-codex__group + .monster-codex__group {
  margin-top: 16px;
}

.monster-codex__group-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 2px 8px;
  padding-bottom: 6px;
  color: #315a7c;
  border-bottom: 1px solid #e8eaec;
  font-size: 13px;
  font-weight: 700;
}

.monster-codex__group-title em {
  color: #9aa3b1;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
}

.monster-codex__list {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  align-content: start;
  gap: 8px;
}

.monster-codex__groups::-webkit-scrollbar {
  width: 6px;
}

.monster-codex__item {
  min-width: 0;
  min-height: 64px;
  padding: 10px;
  border-radius: 10px;
  background: #fff;
  border: 1px solid #e8eaec;
  cursor: pointer;
  transition: all 0.2s ease;
}

@media (max-width: 1180px) and (min-width: 901px) {
  .monster-codex__list {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

.monster-codex__item.active {
  border-color: #2d8cf0;
  background: #f7fbff;
  box-shadow: 0 4px 12px rgba(45, 140, 240, 0.08);
}

.monster-codex__item-head,
.monster-codex__skill-head,
.monster-codex__title-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.monster-codex__item-head {
  min-width: 0;
}

.monster-codex__item-name,
.monster-codex__skill-name {
  font-weight: 600;
  color: #17233d;
}

.monster-codex__item-name {
  display: block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.monster-codex__item-meta {
  display: grid;
  grid-template-columns: auto auto minmax(0, 1fr);
  gap: 4px;
  margin-top: 8px;
}

.monster-codex__item-label {
  min-width: 0;
  padding: 2px 5px;
  overflow: hidden;
  color: #606b7b;
  background: #f2f4f7;
  border: 1px solid #e1e5eb;
  border-radius: 3px;
  font-size: 10px;
  line-height: 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.monster-codex__item-label.is-power {
  color: #ad6800;
  background: #fff7e6;
  border-color: #ffd591;
}

.monster-codex__item-label.is-magic {
  color: #096dd9;
  background: #e6f7ff;
  border-color: #91d5ff;
}

.monster-codex__item-label.is-map {
  color: #237804;
  background: #f6ffed;
  border-color: #b7eb8f;
}

.monster-codex__hero-meta {
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  color: #808695;
}

.monster-codex__section {
  margin-top: 12px;
  padding: 12px;
  border-radius: 12px;
  background: #fff;
  border: 1px solid #f0f0f0;
}

.monster-codex__section:last-child {
  margin-bottom: 80px;
}

.monster-codex__section-title {
  margin-bottom: 10px;
  font-size: 15px;
  font-weight: 700;
  color: #17233d;
}

.monster-codex__stats {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 7px;
}

.monster-codex__stat,
.monster-codex__skill-card {
  padding: 9px;
  border-radius: 10px;
  background: #fafafa;
  border: 1px solid #e8eaec;
}

.monster-codex__stat span {
  display: block;
  color: #808695;
  font-size: 12px;
}

.monster-codex__stat strong {
  display: block;
  margin-top: 4px;
  color: #17233d;
  font-size: 15px;
}

.monster-codex__skills {
  display: grid;
  grid-template-columns: 1fr;
  gap: 7px;
}

.monster-codex__skill-card {
  cursor: default;
}

.monster-codex__skill-short,
.monster-codex__text {
  color: #515a6e;
  line-height: 1.7;
  white-space: pre-wrap;
}

.monster-codex__skill-short {
  margin-top: 6px;
  font-size: 12px;
}

.monster-codex__sub-empty {
  color: #808695;
}

.monster-codex__hero h2 {
  color: #17233d;
}

.monster-codex__list::-webkit-scrollbar,
.monster-codex__detail::-webkit-scrollbar {
  width: 6px;
}

.monster-codex__groups::-webkit-scrollbar-track,
.monster-codex__detail::-webkit-scrollbar-track {
  background: #f5f7f9;
  border-radius: 999px;
}

.monster-codex__groups::-webkit-scrollbar-thumb,
.monster-codex__detail::-webkit-scrollbar-thumb {
  background: #d7dbe3;
  border-radius: 999px;
}

.monster-codex--dark .monster-codex__sidebar,
.monster-codex--dark .monster-codex__detail {
  background: linear-gradient(180deg, #293042 0%, #202636 100%);
  border-color: rgba(255, 255, 255, 0.08);
}

.monster-codex--dark .monster-codex__item,
.monster-codex--dark .monster-codex__stat,
.monster-codex--dark .monster-codex__skill-card {
  background: rgba(255, 255, 255, 0.04);
  border-color: rgba(255, 255, 255, 0.08);
}

.monster-codex--dark .monster-codex__group-title {
  color: #9fc8ed;
  border-bottom-color: rgba(255, 255, 255, 0.12);
}

.monster-codex--dark .monster-codex__group-title em {
  color: #9ca8bc;
}

.monster-codex--dark .monster-codex__item-label {
  color: #c1c8d6;
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(255, 255, 255, 0.12);
}

.monster-codex--dark .monster-codex__item-label.is-power {
  color: #ffc069;
  background: rgba(250, 140, 22, 0.12);
  border-color: rgba(250, 140, 22, 0.3);
}

.monster-codex--dark .monster-codex__item-label.is-magic {
  color: #69c0ff;
  background: rgba(24, 144, 255, 0.12);
  border-color: rgba(24, 144, 255, 0.3);
}

.monster-codex--dark .monster-codex__item-label.is-map {
  color: #95de64;
  background: rgba(82, 196, 26, 0.12);
  border-color: rgba(82, 196, 26, 0.3);
}

.monster-codex--dark .monster-codex__section-title,
.monster-codex--dark .monster-codex__item-name,
.monster-codex--dark .monster-codex__skill-name,
.monster-codex--dark .monster-codex__stat strong,
.monster-codex--dark h2 {
  color: #f3e9d2;
}

.monster-codex--dark .monster-codex__item-meta,
.monster-codex--dark .monster-codex__hero-meta,
.monster-codex--dark .monster-codex__stat span,
.monster-codex--dark .monster-codex__skill-short,
.monster-codex--dark .monster-codex__text,
.monster-codex--dark .monster-codex__empty,
.monster-codex--dark .monster-codex__sub-empty,
.monster-codex--dark .monster-codex__detail--empty {
  color: #b8c0d4;
}

@media (max-width: 900px) {
  .monster-codex {
    flex-direction: column;
    height: auto;
    max-height: none;
    overflow: visible;
  }

  .monster-codex__sidebar {
    width: 100%;
    flex-basis: auto;
    min-height: 0;
    max-height: calc(var(--app-height) - 120px);
    overflow: hidden;
  }

  .monster-codex__list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .monster-codex__stats {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .monster-codex__detail {
    max-height: calc(var(--app-height) - 120px);
    overflow: auto;
  }

  .monster-codex__skills {
    grid-template-columns: 1fr;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MonsterCodexPanel.vue